module.exports = __webpack_public_path__ + "img/RKC-min.b99e64ae.png";